import { CountryISO3, DialCodeId } from '@previo/codebooks'

export type PSelectGroup<T, TKey extends string = string> = {
  key: TKey
  label: string
  items: T[]
  itemValue: keyof T
  itemText: ((item: T) => string) | keyof T
}

export type PPhoneInputFieldType = {
  dialCodeId: DialCodeId | null
  number: string | null
}

export type PPhoneInputFieldDialCode = {
  id: DialCodeId
  dialCode: string
  countryCodeIso3: CountryISO3
  countryName: string
}

export enum PTextInputFieldEnum {
  TEXT = 'text',
  EMAIL = 'email',
  NUMBER = 'number',
  DECIMAL = 'decimal',
}

export type PSegmentPickerItem = {
  icon?: null | string
  label?: null | string | (() => string)
  value: string | number
}

export enum PTimeInputFieldIncrement {
  FULL = 60,
  HALF = 30,
  QUARTER = 15,
}

export type Placeholder = {
  key: string
  label: string
}

export enum PWysiwygTextareaEditorActions {
  BOLD = 'wysiwyg_bold',
  ITALIC = 'wysiwyg_italic',
  UNDERLINE = 'wysiwyg_underline',
  UNORDERED_LIST = 'wysiwyg_unordered',
  ORDERED_LIST = 'wysiwyg_ordered',
  LINK = 'wysiwyg_link',
  PLACEHOLDERS = 'wysiwyg_placeholder_dropdown',
}

export enum PWysiwygTextInputFieldFormat {
  BRACKETS = 'brackets',
  CURLY = 'curly',
}

export enum PPriceInputFieldPrecision {
  TWO = 2,
  FOUR = 4,
}

export type PSuggestionInputFieldComponent = {
  hidePopup: () => void
  showSuggester: () => void
  setInputValue: (value: string | null) => void
}

export enum PInputAutofocusType {
  INPUT = 'INPUT',
  DROPDOWN = 'DROPDOWN',
}
